export default __webpack_public_path__ + "static/media/eliqx-how-it-works-step-1.29da2af8.jpg";